import { render } from "./ResendMail.vue?vue&type=template&id=c5d5dce4"
import script from "./ResendMail.vue?vue&type=script&lang=js"
export * from "./ResendMail.vue?vue&type=script&lang=js"

import "./ResendMail.vue?vue&type=style&index=0&id=c5d5dce4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__